import styled from '@emotion/styled';
import { MenuItem, blue, grey, tokens } from '@galaxy-react/core';

export const StyledGlobalMenuItem = styled(MenuItem)<{
  isSelected?: boolean;
  isSubMenuItem?: boolean;
}>(({ isSelected, isSubMenuItem }) => ({
  minHeight: 36,
  '&.fui-MenuItem': {
    position: 'relative',
    margin: 0,
    gap: 0,
    minWidth: '100%',
    width: '100%',
    alignItems: 'center',
    color: isSubMenuItem ? blue[700] : grey[800],
    backgroundColor: isSelected ? tokens.colorTransparentBackgroundHover : 'inherit',
    '& .fui-MenuItem__content': {
      width: '100%',
    },
    '&:before': {
      display: isSelected ? 'block' : 'none',
      content: "''",
      position: 'absolute',
      left: 0,
      // top: '50%',
      top: '16px',
      width: 3,
      height: 16,
      borderRadius: 99,
      backgroundColor: isSubMenuItem ? blue[500] : tokens.colorBrandStroke2,
      // transform: 'translateY(-50%)',
    },
  },
}));
